<link href="https://unpkg.com/bootstrap-css-only@4.4.1/css/bootstrap.min.css" rel="stylesheet">
<link href="https://unpkg.com/@fortawesome/fontawesome-free@5.15.1/css/all.css" rel="stylesheet">
<link href="https://unpkg.com/angular-calendar@0.28.22/css/angular-calendar.css" rel="stylesheet">
<link href="https://unpkg.com/flatpickr@4.6.6/dist/flatpickr.css" rel="stylesheet">


<section class="content-header  p-3 my-4 mx-1 rounded text-white " style="background-color: #132a42;" >
    <div class="d-flex justify-content-between pt-1 align-items-center">
        <h3 ><strong>{{loggedInUserFullname}}'s Calendar</strong></h3>
    </div>
</section>
<div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-5 " style="min-width: 48%;"  >
<!--<mwl-demo-utils-calendar-header class="p-5 m-5"  [(view)]="view" [(viewDate)]="viewDate">
</mwl-demo-utils-calendar-header>

<div [ngSwitch]="view" class="pt-5 mt-5">
  <mwl-calendar-month-view
    *ngSwitchCase="'month'"
    [viewDate]="viewDate"
    [events]="events"
    [activeDayIsOpen]="true"
    (eventClicked)="eventClicked($event)"
  >
  </mwl-calendar-month-view>
  <mwl-calendar-week-view
    *ngSwitchCase="'week'"
    [viewDate]="viewDate"
    [events]="events"
    (eventClicked)="eventClicked($event)"
  >
  </mwl-calendar-week-view>
  <mwl-calendar-day-view
    *ngSwitchCase="'day'"
    [viewDate]="viewDate"
    [events]="events"
    (eventClicked)="eventClicked($event)"
  >
  </mwl-calendar-day-view>
</div>
</div>
-->

<mwl-demo-utils-calendar-header
  [(view)]="view"
  [(viewDate)]="viewDate"
  (viewDateChange)="fetchEvents()"
  (viewChange)="fetchEvents()"
>
</mwl-demo-utils-calendar-header>

<ng-template #loading>
  <div class="text-center">
    <i class="fas fa-spin fa-spinner fa-5x"></i> <br />
    Loading events...
  </div>
</ng-template>

<div *ngIf="events$ | async; else loading; let events">
  <div [ngSwitch]="view">
    <mwl-calendar-month-view
      *ngSwitchCase="'month'"
      [viewDate]="viewDate"
      [events]="events"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day)"
      (eventClicked)="eventClicked($event.event)"
    >
    </mwl-calendar-month-view>
    <mwl-calendar-week-view
      *ngSwitchCase="'week'"
      [viewDate]="viewDate"
      [events]="events"
      (eventClicked)="eventClicked($event.event)"
    >
    </mwl-calendar-week-view>
    <mwl-calendar-day-view
      *ngSwitchCase="'day'"
      [viewDate]="viewDate"
      [dayStartHour]="8"
      [dayEndHour]="18"
      [events]="events"
      (eventClicked)="eventClicked($event.event)"
    >
    </mwl-calendar-day-view>
  </div>
</div>
</div>




<ul class="nav nav-tabs text-center pt-5 d-flex justify-content-center">

    <li class="nav-item">
      <a class="nav-link active" style="cursor: pointer;" id="todaysappointmentsview" translate >Todays Appointments</a>
    </li>
      <li class="nav-item">
        <a class="nav-link active" style="cursor: pointer;" id="allappointmentsview" translate >All Appointments</a>
      </li>

        </ul>

<!--*********************************************************************************************************************************************************************************************************************************-->
<div id="allappointments">
<div class="col-md-12 bg-muted p-0  " style="min-height: 15%; background: white;" id="allTableview" >
    <div class=" d-flex justify-content-between row w-85 mt-2 mx-1">
    
  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
        <div id="notificationSlide" class="carousel slide " data-ride="carousel">
        
  
            <!-- Indicators -->
            <ul class="carousel-indicators">
                <li data-target="#assetSlide" data-slide-to="0" class="active"></li>
                <li data-target="#assetSlide" data-slide-to="1"></li>
                <li data-target="#assetSlide" data-slide-to="2"></li>
            </ul>
  
            <!-- The slideshow -->
            <div class="carousel-inner">
                <div class="carousel-item active">
  
                  
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3 " style="background-color: #132a42;" > <div class="p-1 mr-3">
                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  [(ngModel)]="searchText"
                   aria-label="Search" >
                 </div></h6>
                        
                <div  style="overflow:auto;" *ngIf="mytableappointment!=['no appointment'] else no_appointment_content" >
                    <table class="table w-100  text-center"  style="font-size: 12px;">
                                
                       
                        <th class=" p-2" translate>Full Name</th>
                        <th class="text-center p-2" translate>Request Type</th>
                        <th class="text-center p-2" translate>Sales Rep</th>
                        <th class="text-center p-2" translate>Phone</th>
                        <th class="text-center p-2" translate>Time In</th>
                        <th class="text-center p-2" translate>Time Out</th>
                        <th class="text-center p-2" translate>Tag</th>
                        <th class="text-center p-2" translate>Status</th>
                        <th class="text-center p-2"  *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() " translate>Action</th>
                        <th *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() "></th>
                       
                        <ng-container *ngFor='let list of mytableappointment | filter:searchText '>
                          <tr style="color: purple;" *ngIf='checkbarScan(list.barScan) && list.requestType!="Browsing" else other_content'>
                              <td class="p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                              <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                              <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.salesRep}}</td>
                             <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                             <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                             <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                             <td class="text-center p-3" (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                             
                            
                            
                            
                             <td  *ngIf="list.status==''" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='No Show'" class="text-danger text-center  p-3" ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3" ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-3"><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3"><strong>{{list.status}}</strong></td>
    
                              <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                  <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                  <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                  <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                  <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                  <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                  <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                 
                              </td>
                             
                                         <td> <i class="fa fa-toggle-on text-info p-2"  *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() "style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                          </tr>
    
    
    
                          
    
                          <ng-template #other_content>
    
    
    
    
                              <tr class="text-success " *ngIf='list.requestType=="Browsing" else else_content'>
                                  <td class="p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                  <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                                  <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.salesRep}}</td>
                                 <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                                 <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                                 <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                                 <td class="text-center p-3" (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                                 
                                
                                
                                
                                 <td  *ngIf="list.status==''" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='No Show'" class="text-danger text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-3"><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3"><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status==''" class="text-center  p-3"><strong>{{list.status}}</strong></td>
    
      
                                  <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                      <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                  <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                  <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                  <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                  <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                  <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                     
                                  </td>
                                 
                                             <td> <i class="fa fa-toggle-on text-info p-2"  *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() " style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                              </tr>
    
    
    
    
    
    <ng-template #else_content>
    
    
                          <tr >
                              <td class="p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                              <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                              <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.salesRep}}</td>
                             <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                             <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                             <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                             <td class="text-center p-3" (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                            
                            
                            
                             <td  *ngIf="list.status==''" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='No Show'" class="text-danger text-center  p-3" ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3" ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-3"><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3"><strong>{{list.status}}</strong></td>
    
                              <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                 
                               <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                  <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                  <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                  <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                  <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                  <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                              
                              </td>
                             
                                         <td></td>
                          </tr>
                          </ng-template><!--End of Else Content-->
    
                          </ng-template><!--End of Other Content-->


                  
                      </ng-container>
                    </table>
                  
               </div>
               <ng-template #no_appointment_content>
                <table class="table w-100  text-center"  style="font-size: 12px;">
                    
           
                    <th class=" p-2" translate>Full Name</th>
                    <th class="text-center p-2" translate>Request Type</th>
                    <th class="text-center p-2" translate>Sales Rep</th>
                    <th class="text-center p-2" translate>Phone</th>
                    <th class="text-center p-2" translate>Time In</th>
                    <th class="text-center p-2" translate>Time Out</th>
                    <th class="text-center p-2" translate>Tag</th>
                    <th class="text-center p-2" translate>Status</th>
         <tr>
                  <td colspan="8" class="col-span-8 text-center">no appointment
                </td>
            </tr>
                </table>
              </ng-template>
                    </div>
                </div>
                   
            </div>
  
   
        </div>
      
  </div>
  
  
  
        </div>
  
        </div>

</div>
<!--*********************************************************************************************************************************************************************************************************************************-->
<div id="todaysappointments">
    <div class="col-md-12 bg-muted p-0  " style="min-height: 15%; background: white;" id="allTableview" >
        <div class=" d-flex justify-content-between row w-85 mt-2 mx-1">
        
      <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
            <div id="notificationSlide" class="carousel slide " data-ride="carousel">
            
      
                <!-- Indicators -->
                <ul class="carousel-indicators">
                    <li data-target="#assetSlide" data-slide-to="0" class="active"></li>
                    <li data-target="#assetSlide" data-slide-to="1"></li>
                    <li data-target="#assetSlide" data-slide-to="2"></li>
                </ul>
      
                <!-- The slideshow -->
                <div class="carousel-inner">
                    <div class="carousel-item active">
      
                      
                        <div class=" border p-3 m-1 rounded   " >
                            <h6 class="table-heading rounded text-white text-center p-3"  style="background-color: #132a42;" > <div class="p-1 mr-3">
                                <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  [(ngModel)]="searchText"
                       aria-label="Search" >
                     </div></h6>
                            
                    <div  style="overflow:auto;" *ngIf="mytabletodayappointment!='no appointment' else no_appointment_content" >
                        <table class="table w-100  text-center"  style="font-size: 12px;">
                                    
                           
                            <th class=" p-2" translate>Full Name</th>
                            <th class="text-center p-2" translate>Request Type</th>
                            <th class="text-center p-2" translate>Sales Rep</th>
                            <th class="text-center p-2" translate>Phone</th>
                            <th class="text-center p-2" translate>Time In</th>
                            <th class="text-center p-2" translate>Time Out</th>
                            <th class="text-center p-2" translate>Tag</th>
                            <th class="text-center p-2" translate>Status</th>
                            <th class="text-center p-2" translate *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">Action</th>
                            <th *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() "></th>
                           
                            <ng-container *ngFor='let list of mytabletodayappointment | filter:searchText '>
                              <tr style="color: purple;" *ngIf='checkbarScan(list.barScan) && list.requestType!="Browsing" else other_content'>
                                  <td class="p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                  <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                                  <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.salesRep}}</td>
                                 <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                                 <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                                 <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                                 <td class="text-center p-3" (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                                 
                                
                                
                                
                                 <td  *ngIf="list.status==''" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='No Show'" class="text-danger text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-3"><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3"><strong>{{list.status}}</strong></td>
        
                                  <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                      <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                      <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                      <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                      <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                      <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                      <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                     
                                  </td>
                                 
                                             <td> <i class="fa fa-toggle-on text-info p-2"  *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() "style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                              </tr>
        
        
        
                              
        
                              <ng-template #other_content>
        
        
        
        
                                  <tr class="text-success " *ngIf='list.requestType=="Browsing" else else_content'>
                                      <td class="p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                      <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                                      <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.salesRep}}</td>
                                     <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                                     <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                                     <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                                     <td class="text-center p-3" (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                                     
                                    
                                    
                                    
                                     <td  *ngIf="list.status==''" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                      <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                      <td  *ngIf="list.status=='No Show'" class="text-danger text-center  p-3" ><strong>{{list.status}}</strong></td>
                                      <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3" ><strong>{{list.status}}</strong></td>
                                      <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-3"><strong>{{list.status}}</strong></td>
                                      <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3"><strong>{{list.status}}</strong></td>
                                      <td  *ngIf="list.status==''" class="text-center  p-3"><strong>{{list.status}}</strong></td>
        
          
                                      <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                          <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                      <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                      <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                      <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                      <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                      <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                         
                                      </td>
                                     
                                                 <td> <i class="fa fa-toggle-on text-info p-2"  *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() " style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                                  </tr>
        
        
        
        
        
        <ng-template #else_content>
        
        
                              <tr >
                                  <td class="p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                  <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                                  <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;"  >{{list.salesRep}}</td>
                                 <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                                 <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                                 <td class="text-center p-3" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                                 <td class="text-center p-3" (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                                
                                
                                
                                 <td  *ngIf="list.status==''" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Pending'" class="text-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='No Show'" class="text-danger text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3" ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Completed'" class="text-success text-center  p-3"><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3"><strong>{{list.status}}</strong></td>
        
                                  <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                     
                                   <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                      <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                      <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                      <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                      <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                      <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                  
                                  </td>
                                 
                                             <td></td>
                                          
                              </tr>
                              </ng-template><!--End of Else Content-->
        
                              </ng-template><!--End of Other Content-->
    
    
                      
                          </ng-container>
                        </table>
                      
                   </div>
                   <ng-template #no_appointment_content>
                    <table class="table w-100  text-center"  style="font-size: 12px;">
                        
               
                        <th class=" p-2" translate>Full Name</th>
                        <th class="text-center p-2" translate>Request Type</th>
                        <th class="text-center p-2" translate>Sales Rep</th>
                        <th class="text-center p-2" translate>Phone</th>
                        <th class="text-center p-2" translate>Time In</th>
                        <th class="text-center p-2" translate>Time Out</th>
                        <th class="text-center p-2" translate>Tag</th>
                        <th class="text-center p-2" translate>Status</th>
             <tr>
                      <td colspan="8" class="col-span-8 text-center">no appointment
                    </td>
                </tr>
                    </table>
                  </ng-template>
                        </div>
                    </div>
                       
                </div>
      
       
            </div>
          
      </div>
      
      
      
            </div>
      
            </div>
    

</div>

      



<!--*********************************************************************************************************************************************************************************************************************************-->
<button id="openClientSearchModalButton" [hidden]="true" data-toggle="modal" data-target="#ClientSearchModal">Open Modal</button>
<!-- Modal -->
<div id="ClientSearchModal" class="modal fade" role="dialog">
    <div class="modal-dialog" style="min-height: 15%; min-width: 68%; background: white;">

        <!-- Modal content-->
        <div class="modal-content " style="min-height: 15%; min-width: 68%; background: white;">
            <div class="modal-header">
            </div>
<div class="col-md-12 bg-muted p-0  " style="min-height: 15%; min-width: 68%; background: white;" id="todayTableview" >
    <div class=" d-flex justify-content-between row w-95 mt-2 mx-1">
    
  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 68%;"  >
        <div id="notificationSlide" class="carousel slide " data-ride="carousel">

         

            <!-- The slideshow -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  ><strong translate>Client Search</strong>   <div class="p-1 mr-3">
                            <form role="form" method="post" [formGroup]="searchForm">
                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded form-control" formControlName='searchPhoneText' type="text" placeholder="Search by Phone Number"  
                   aria-label="Search" >
                   <button class="btn btn-dark mx-1 border border-white rounded text-white " (click)='clientSearch(searchForm.get("searchPhoneText").value)'>Submit</button>
                </form>
                 </div></h6>
                        
                <div  style="overflow:auto;"  >
                    <table class="table w-100  text-center"  style="font-size: 12px;">
                                
   
                      <ng-container *ngFor='let list of clientSearchList'>
                    <table class="col-md-12 border" *ngIf="list!='no clients found' else elseblock">
                        <thead class="border">
                        <th class=" p-2 border" translate>Full Name</th>
                        <th class="text-center p-2 border" translate>Phone Number</th>
                        <th class="text-center p-2 border" translate>Email</th>
                        </thead>
                        <tr  >
                            
                            <td  class="p-2 border " style="cursor: pointer;" (click)="openClientDetails(list)" data-dismiss="modal">{{list.fullName}}</td>     
                            <td  class="p-2 border" style="cursor: pointer;" (click)="openClientDetails(list)"  data-dismiss="modal">{{list.phoneNumber}}</td>   
                            <td  class="p-2 border" style="cursor: pointer;" (click)="openClientDetails(list)"  data-dismiss="modal">{{list.email}}</td>   
                            
                           
                       
                        </tr>
                    </table>      
                    </ng-container>

                    <ng-template #elseblock> 
                        <td  class="p-3 border"  data-dismiss="modal" style="cursor: pointer;" translate >"No Results"</td>  
                    </ng-template>
                    </table>
               </div>
                    </div>
                </div>
                   
            </div>

   
        </div>
      
</div>

 

        </div>

        </div>



    </div>
    </div>
    </div>



    
<!--*********************************************************************************************************************************************************************************************************************************-->
<button id="openSalesRepAvailabilityModalButton" [hidden]="true" data-toggle="modal" data-target="#SalesRepAvailabilityModal">Open Modal</button>
<!-- Modal -->
<div id="SalesRepAvailabilityModal" class="modal fade" role="dialog">
    <div class="modal-dialog" style="min-height: 15%; min-width: 68%; background: white;">

        <!-- Modal content-->
        <div class="modal-content" style="min-height: 15%; min-width: 68%; background: white;">
            <div class="modal-header">
            </div>
<div class="col-md-12 bg-muted p-0  " style="min-height: 15%; min-width: 68%; background: white;" id="todayTableview" >
    <div class=" d-flex justify-content-between row w-95 mt-2 mx-1">
    
  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 68%;"  >
        <div id="notificationSlide" class="carousel slide " data-ride="carousel">

         

            <!-- The slideshow -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3 bg-dark"  ><strong translate>Sales Representative Availability</strong>   <div class="p-1 mr-3">
                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  [(ngModel)]="searchText"
                   aria-label="Search" >
                 </div></h6>
                        
                <div  style="overflow:auto;"  >
                    <table class="table w-100  text-center"  style="font-size: 12px;">
                                
                       
                                                

                      
                        <tr *ngFor='let list of tablerequestTypearray |  filter:searchText'>
                            <ng-container *ngFor='let table of list | keyvalue'>
                            <td *ngIf="table.key==' ' else elseblock" class="p-3 border"   >{{table.value}}</td>      
                            
                            <ng-template #elseblock> 
                                <td  class="p-3 border"  data-dismiss="modal" style="cursor: pointer;" (click)='createAptFromFreeTime(list[" "],table.value)'>{{table.value}}</td>  
                            </ng-template>
                        </ng-container>
                        </tr>
                        
         
                    </table>
               </div>
                    </div>
                </div>
                   
            </div>

   
        </div>
      
</div>

 

        </div>

        </div>



    </div>
    </div>
    </div>



    
<!----------In Progress Person Count Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #inProgressModal let-modal >
    <div class="modal-header" >
     <h5 class="modal-title" id="statuLabel"   translate>Status Update</h5>
     <button type="button" class="close"  style=" outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="tagForm" >
     
        


      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold"  translate>Person Count</label>
      <div class="col-sm-8">  
        <input class="px-2 form-control"  id="personcount" type="text">
        </div>
      </div>
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="button" class="btn btn-primary" (click)=inprogressAppointment(); translate>Save</button>
      </div>
     </form>
    </div>
   </ng-template>


<!----------Tag Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #tagModal let-modal >
    <div class="modal-header" >
     <h5 class="modal-title" id="statuLabel"  >Tag</h5>
     <button type="button" class="close"  style=" outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
     </button>
    </div>
    
    <div class="modal-body">
     <form [formGroup]="tagForm" >
     
        <div class="form-group row">
            <label class="col-sm-4 col-form-label font-weight-bold"  translate>ID</label>
          <div class="col-sm-8">  
            <input class="px-2 form-control bg-white border-0" disabled formControlName="pid" id="pid" type="text">
            </div>
          </div>
  
       <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate >Full Name</label>
      <div class="col-sm-8">  
        <input class="px-2 form-control bg-white border-0" disabled formControlName="fullName" id="fullName" type="text">
        </div>
      </div>


      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold"  translate>Tag</label>
      <div class="col-sm-8">  
        <input class="px-2 form-control" formControlName="tag" id="tag" type="text">
        </div>
      </div>
     
      <div class="modal-footer">
       <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
       <button type="submit" class="btn btn-primary" (click)=saveIndividualTag(); translate>Confirm</button>
      </div>
     </form>
    </div>
   </ng-template>


<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="SuccessModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';"  translate>Appointment has been saved.</h4>
                                                </div>
                    
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getSalesRepAppointment()'   translate data-dismiss="modal">Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>
                    
        <!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Complete Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessStatusUpdateModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessStatusUpdateModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="SuccessStatusUpdateModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Appointment status has been updated.</h4>
                                                </div>
                    
                                               
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getSalesRepAppointment()' data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>



                    
<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Block/Day Off Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openOffSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#OffSuccessModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="OffSuccessModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                   
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                                                <div class="modal-body text-danger" *ngFor='let x of OffMessage'>
                                                    <p class="my-0 py-0">{{x}}</p>
                                                </div>
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';"  translate>Your changes have been saved</h4>
                                                </div>
                    
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getSalesRepAppointment()'   data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>
           
<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccesssModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccesssModal">Open Modal</button>
<!-- Modal -->
<div id="SuccesssModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

           <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                            <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" >Your changes has been saved.</h4>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" (click)='getSalesRepAppointment()'  translate  data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>
</div>


         
         

  
        <!------------------------------------------------------------------------------------------------------------------------------------------
                        Success DeleteModal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openSuccessDeleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessDeleteModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="SuccessDeleteModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                               <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                </div>
                                <div class="modal-body " style="background: black;">
                                    <div class="row p-5 ">
                                        <div class="col-sm-12 w-100">
                                            <div class="d-flex flex-column justify-content-between  row w-100 m-0">
                    
                    
                                                <img class="px-3"
                                                    style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                                    src="./assets/logo2020w.png" />
                    
                                                <div class="w-100 text-center">
                                                    <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
                                                </div>
                    
                                                <div class="border  bg-white "></div>
                                                <div class="w-100 text-center">
                                                    <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Appointment has been deleted.</h4>
                                                </div>
                    
                                               
                    
                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default text-center" (click)='getSalesRepAppointment()'  translate data-dismiss="modal">Close</button>
                                </div>
                            </div>
                    
                        </div>
                    </div>
                    
                    
                    <!------------------------------------------------------------------------------------------------------------------------------------------
                                           Error Modal
                                        ------------------------------------------------------------------------------------------------------------------------------------------>
                    <button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
                    <!-- Modal -->
                    <div id="ErrorModal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                    
                            <!-- Modal content-->
                            <div class="modal-content">
                                <div class="modal-header">
                    
                                    <h4 class="modal-title text-danger" translate>ERROR</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body text-danger">
                                    <p>{{error}}</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" routerLink='/main-dashboard' data-dismiss="modal" translate>Close</button>
                                </div>
                            </div>
                    
                        </div>
</div>

                    
